/** @see https://developers.google.com/search/docs/crawling-indexing/block-indexing */
export const noindex = () => ({
  content: 'noindex',
  name: 'robots',
});
